import { render, staticRenderFns } from "./SpCard.vue?vue&type=template&id=799cd815"
import script from "./SpCard.vue?vue&type=script&lang=js"
export * from "./SpCard.vue?vue&type=script&lang=js"
import style0 from "./SpCard.vue?vue&type=style&index=0&id=799cd815&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports